import React, { forwardRef } from "react";
import { StyledBenefitsItem } from "./styledHomePageBenefits";
import { StyledDecorationElementHomePage } from "../styledHomePage";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import BringTelegram from "../../../assets/images/home-page/bring-block/bring-telegram.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const BenefitsListItem = forwardRef(({ item }, ref) => {
  const { icon, title, description, link, manualKey } = item;

  return (
    <StyledBenefitsItem ref={ref}>
      <div className="container-responsive">
        <div className="block-responsive">
          <div className="circle">
            <NavLink
              to={{
                pathname: link,
                state: { manualKey }
              }}
            >
              <LazyLoadImage
                src={Object.values(icon).toString()}
                alt=""
              />
            </NavLink>
          </div>
          <StyledDecorationElementHomePage
            color="#FFFFFF"
            size="20"
            display="block"
            position="center"
            mt="20"
            as={NavLink}
            to={link}
            mb="10"
            weight="700"
            className="card-title"
          >{title}</StyledDecorationElementHomePage>
          <StyledDecorationElementHomePage
            color="#FFFFFF"
            size="16"
            weight="300"
            lineHeight="20"
            className="card-description"
          >{description}</StyledDecorationElementHomePage>
        </div>
      </div>
    </StyledBenefitsItem>
  );
});

export default motion(BenefitsListItem);